import { PayerError } from './errors';

export class WrappedResponse<T> {
  promise: Promise<T | string | Blob | null>;
  constructor(promise: Promise<T | string | Blob | null>) {
    this.promise = promise;
  }

  withStringResponse = (): Promise<string> => {
    return this.promise.then(response => {
      if (typeof response === 'string') {
        return response;
      } else {
        throw new PayerError({
          detail: `Expected string response but was object or null: ${JSON.stringify(response)}`,
        });
      }
    });
  };

  withObjectResponse = (): Promise<T> => {
    return this.promise.then(response => {
      if (response === null || typeof response === 'string' || response instanceof Blob) {
        throw new PayerError({
          detail: `Expected object response but was string, blob, or null: ${response}`,
        });
      } else {
        return response;
      }
    });
  };

  withBlobResponse = (): Promise<Blob> => {
    return this.promise.then(response => {
      if (response instanceof Blob) {
        return response;
      } else {
        throw new PayerError({
          detail: `Expected blob response but was ${typeof response}: ${response}`,
        });
      }
    });
  };

  withEmptyResponse = (): Promise<void> => {
    return this.promise.then(response => {
      if (!response) {
        return;
      } else {
        throw new PayerError({
          detail: `Expected empty response but was object or string: ${JSON.stringify(response)}`,
        });
      }
    });
  };
}
